import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useIsAdmin } from '@/lib/auth'

function Index() {
  // False while viewing as a user, who lands on their own tickets.
  const isAdmin = useIsAdmin()
  const navigate = useNavigate()
  // SPA navigation only — tokens live in memory, so a window.location redirect
  // here reloads the app, drops the session, and loops back through login.
  useEffect(() => {
    navigate({ to: (isAdmin ? '/admin' : '/tickets') as never, replace: true })
  }, [isAdmin, navigate])
  return <div className="p-8">Redirecting…</div>
}

export const Route = createFileRoute('/')({ component: Index })
